import {
  CABINET_COMMON_COLOR_PART_IDS,
  FEATUREGROUP_PART_ID,
  MITER_EDGE_NAMES,
  MITER_UNDERWRAP_EDGE_NAMES,
  SHAPE_PART_ID,
  SHAPE_TYPE,
  SQFT_APPLIANCES,
  SQFT_APPLIANCES_BATHROOM,
  SQFT_APPLIANCES_ON_TOP_SHAPES,
  WATERFALL_EDGE_NAMES
} from "../constants";
import store from "./../../../store";
import {getCountertopFeatureGroup, getCurrentLayout} from "../../appLayout";
import workspace from "../components/canvas/core/workspace";
import {getStringFeatureName} from "../../../misc/helpers";
import {getEdgeFeatures} from "./shapeHelper";
import {isSFTCabinetsGroup} from "./sqftNavigationHelper";
import {getFeatureGroup, getNavItems} from "./sqftHelperUi";
import sqftConfig from "../components/canvas/store/sqftConfig";
import {
  findGLBLink,
  getDepthFromAR3DMetaData,
  getDepthFromDbFeature,
  getHeightFromAR3DMetaData,
  getThirdPartyAR3DMetaData,
  getWidthFromDbFeature
} from "./sqft3dArHelper";
import {getUrlMatchingByColor} from "./cabinetModelUrlMatcher";
import {isFeatureEnabled} from "../../../misc/displayLogic";
import sqftEventManager from "../components/canvas/store/sqftEventManager";
import {getNextWizardSteps} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions2";
import {wizardGroupHasFeatureIncluded} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";

export const getShapeFeatureId = (partId) => {
  const state = store.getState();
  const { sqftFromFeature } = state.sqftState;
  const { wizardIsActive, wizardSelectedValues, wizardActiveItem, wizardActiveStep } = state.wizardState;
  const layout = getCurrentLayout();
  const isCabinetsMode = isSFTCabinetsGroup();

  //1)  For the cabinets we will assign activeFeature from featureGroup
  if (!isCabinetsMode && sqftFromFeature && sqftFromFeature.cartFeature.partId === partId) {
    console.log("new shape featureId from sqftFromFeature", sqftFromFeature.cartFeature.dbFeature.id);
    return sqftFromFeature.cartFeature.dbFeature.id;
  }

  // 1.5) Assign feature by sqftFromFeature that was passed from visualizer quoting tool
  if (wizardIsActive) {
    for (const key in wizardSelectedValues) {
      if (wizardSelectedValues.hasOwnProperty(key)) {
        const selectedFeature = wizardSelectedValues[key] ? wizardSelectedValues[key].selectedFeature : null;
        if (selectedFeature && selectedFeature.partId === partId) {
          return selectedFeature.dbFeature.id;
        }
      }
    }
  }

  const featureGroup = layout.getFeatureGroupByPartId(partId);
  //1.75 search for the same Feature if we entered from Countertop and Need the same Backsplash
  if (featureGroup && sqftFromFeature && wizardIsActive && wizardActiveItem && (sqftFromFeature.cartFeature.partId !== partId)) {
    const neededSharedFeatureName = sqftFromFeature.cartFeature.getSplittedFeatureName();
    const navItems = layout.designNavigationItems({part: featureGroup}, [], "", false, "all");
    const neededNavItem = navItems.find(navItem => {
      return navItem.part?.getSplittedFeatureName()?.toLowerCase() === neededSharedFeatureName?.toLowerCase()
    });
    if (neededNavItem) {
      const currentWizardSteps = getNextWizardSteps(wizardActiveItem, wizardActiveStep, wizardSelectedValues);
      const stepWithFeatureFound = currentWizardSteps.find(step => {
        if (step.stepGroups.length !== 1 || (step.stepGroups[0].groupName !== (featureGroup.dbName || featureGroup.partName))) {
          return false
        }
        return wizardGroupHasFeatureIncluded(step.stepGroups[0], neededNavItem.part)
      });
      if (stepWithFeatureFound) {
        console.log("Same Feature Found that we entered from", neededNavItem.part);
        return neededNavItem.part.dbFeature.id;
      }
    }
  }

  //2) Assign default active feature group feature for the part id
  if (featureGroup && featureGroup.activeFeature && isFeatureEnabled(featureGroup.activeFeature)) {
    console.log("new shape featureId featureGroup activeFeature", featureGroup.activeFeature.dbFeature.id);

    const navItems = getNavItems(featureGroup, '', {}, true, true);
    const availableDbFeatureIds = navItems.map(navItem => navItem.part?.dbFeature?.id);
    if (navItems?.length > 0) {
      // return active feature if it in the wizard
      if (availableDbFeatureIds.includes(featureGroup.activeFeature.dbFeature.id)) {
        return featureGroup?.activeFeature?.dbFeature?.id;
      }

      // return first available item
      return navItems[0].part?.dbFeature?.id;
    }
  }

  //2.5) Assign feature for slab placeholder
  if (partId === SHAPE_PART_ID.slabPlaceHolder) {
    const countertopFeatureGroup = getCountertopFeatureGroup();
    if (sqftFromFeature && sqftFromFeature.cartFeature.partId === countertopFeatureGroup.partId) {
      console.log("new shape featureId from sqftFromFeature for the slabPlaceHolder", sqftFromFeature.cartFeature.dbFeature.id);
      return sqftFromFeature.cartFeature.dbFeature.id;
    }

    if (countertopFeatureGroup && countertopFeatureGroup.activeFeature && isFeatureEnabled(countertopFeatureGroup.activeFeature)) {
      console.log("new shape featureId featureGroup activeFeature for the slabPlaceHolder", countertopFeatureGroup.activeFeature.dbFeature.id);
      return countertopFeatureGroup.activeFeature.dbFeature.id;
    }
  }

  //3) Assign any feature
  //todo
  console.log("new shape featureId", null);
  return null
}
/**
 * This will return sibling feature without special shape with the same height and depth.
 * @param feature
 * @param parentFeature
 * @return {*}
 */
export const getSpacerDbFeature = (feature, parentFeature) => {
  if (feature && parentFeature) {
    const url = getUrlMatchingByColor(feature.dbFeature, parentFeature);
    const metaData = getThirdPartyAR3DMetaData(feature.dbFeature, url);
    if (!metaData) {
      return;
    }

    const shapeHeight = getHeightFromAR3DMetaData(metaData);
    const shapeDepth = getDepthFromAR3DMetaData(metaData);
    if (shapeHeight === null || shapeDepth === null) {
      return;
    }

    const relatedFeatures = parentFeature.getFeatureRelatedFeatures();
    return relatedFeatures.find(siblingDbFeature => {
      const siblingFeatureUrl = getUrlMatchingByColor(siblingDbFeature, parentFeature);
      const siblingFeatureMetaData = getThirdPartyAR3DMetaData(siblingDbFeature, siblingFeatureUrl);
      if (!siblingFeatureMetaData) {
        return false;
      }

      const siblingFeatureHeight = getHeightFromAR3DMetaData(siblingFeatureMetaData);
      const siblingFeatureDepth = getDepthFromAR3DMetaData(siblingFeatureMetaData);

      if (!Array.isArray(siblingFeatureMetaData.SpecialShape)
        && shapeHeight === siblingFeatureHeight
        && shapeDepth === siblingFeatureDepth
      ) {
        return siblingDbFeature
      }
    });
  }
}

export const getFeatureNameById = (featureId) => {
  const layout = getCurrentLayout();
  const feature = layout.getFeatureById(featureId);
  const intl = workspace.intl;
  const state = store.getState();
  const fabricatorData = state.fabricatorState;

  return getStringFeatureName(feature, intl?.messages, intl?.locale, fabricatorData);
}

export const shouldChangeCabinetShapePartId = (relatedParentFeature, newFeature) => {
  //console.log("relatedParentFeature", relatedParentFeature);
  //console.log("sqftFromFeature", sqftFromFeature);
  if (!newFeature || !relatedParentFeature) {
    return false
  }

  const sqftFromFeatureParentGroup = newFeature.getParent();
  const relatedParentParentGroup = relatedParentFeature.getParent();

  if ((CABINET_COMMON_COLOR_PART_IDS).includes(sqftFromFeatureParentGroup.partId)
    && (CABINET_COMMON_COLOR_PART_IDS).includes(relatedParentParentGroup.partId)
  ) {
    return newFeature.dbFeature?.id !== relatedParentFeature.dbFeature?.id;
  }

  return false
}

export const getEdgeFilterByValue = (filterValue = 'Waterfall') => {
  const state = store.getState();
  const filterGroups = state.filterState.filterGroups;
  const edgeFilterGroup = filterGroups.find(group => group.name === "Edge" || group.name === "Edge Profile");

  return edgeFilterGroup ? edgeFilterGroup.values.filter(group => group.value === filterValue) : [];
};

export const isWaterfallFeature = (edgeFeatureId, currentEdgeFeature = null) => {
  const edgeFeature = currentEdgeFeature
    ? {part: currentEdgeFeature}
    : getEdgeFeatures().find(edge => edge.part.dbFeature.id === edgeFeatureId);

  if (!edgeFeature) {
    return false
  }

  const intl = workspace.intl;
  const state = store.getState();
  const fabricatorData = state.fabricatorState;
  let edgeNameTranslated;
  if (intl) {
    edgeNameTranslated = getStringFeatureName(edgeFeature.part, intl.messages, intl.locale, fabricatorData);
  } else {
    edgeNameTranslated = edgeFeature.part.getFeatureName();
  }

  const normalizedEdgeName = edgeNameTranslated.toLowerCase();

  return WATERFALL_EDGE_NAMES.some(waterfallEdgeName => normalizedEdgeName.includes(waterfallEdgeName))
}

export const isMiterEdge = (featureId, currentEdgeFeature = null) => {
  const edge = currentEdgeFeature
    ? {part: currentEdgeFeature}
    : getEdgeFeatures().find(edge => edge.part.dbFeature.id === featureId);

  if (!edge) {
    return false
  }

  const edgeName = edge.part.getFeatureName();

  return MITER_EDGE_NAMES.includes(edgeName.toLowerCase());
}

export const getEdgeByFeatureId = (featureId) => {
  const navItems = getEdgeFeatures();
  if (!navItems) {
    return null
  }

  let edge = navItems.find(edge => edge.part.dbFeature.id === featureId);
  if (!edge) {
    return null
  }

  return edge
}

const parseNumberFromString = (str) => {
  // Convert the string "1 1/2" to 1.5
  const fractionMatch = str.match(/(\d+)\s+(\d+)\/(\d+)/);
  if (fractionMatch) {
    const [_, whole, numerator, denominator] = fractionMatch;
    void _;
    return parseFloat(whole) + (parseFloat(numerator) / parseFloat(denominator));
  }

  // Convert a string like "1 1/2", "2-3" into separate numbers
  const numberMatch = str.match(/\d+(\.\d+)?/g);
  if (numberMatch) {
    return Math.max(...numberMatch.map(Number));
  }

  return null;
};

export const getMiterEdgeHeight = (featureId = null) => {
  //get height from featureName
  if (featureId) {
    const miterEdgeFeature = getEdgeByFeatureId(featureId);
    if (miterEdgeFeature) {
      const edgeName = miterEdgeFeature.part.getFeatureName();

      const heightFromFeatureName = parseNumberFromString(edgeName);

      if (edgeName !== 'Rimrock - 981' // don't get height from this edge
        && heightFromFeatureName > 0.5
      ) {
        return heightFromFeatureName
      }
    }
  }

  return sqftConfig.measureUnit === "Imperial" ? sqftConfig.miteredEdgeAdditionalImperialArea : sqftConfig.miteredEdgeAdditionalMetricArea;
};

export const getMiterEdgeFeature = () => {
  const navItems = getEdgeFeatures();
  if (!navItems) {
    return null
  }

  let edgeFeature = navItems.find(edge => {
    return MITER_EDGE_NAMES.includes(edge.part.partName.toLowerCase());
  });

  if (!edgeFeature) {
    edgeFeature = navItems.find(edge => edge.part.partName.toLowerCase().includes('miter'));
  }

  if (edgeFeature) {
    return edgeFeature.part
  }

  return null
}

export const getMiterUnderwrap = () => {
  const navItems = getEdgeFeatures();
  if (!navItems) {
    return null
  }

  let edgeFeature = navItems.find(edge => {
    return MITER_UNDERWRAP_EDGE_NAMES.includes(edge.part.partName.toLowerCase());
  });

  if (edgeFeature) {
    return edgeFeature.part
  }

  return null
}

export const getBumpoutFeature = () => {
  const bumpoutFeatureGroup = getFeatureGroup(FEATUREGROUP_PART_ID.specialty_cut_and_designs);
  const layout = getCurrentLayout();

  return layout.designNavigationItems(bumpoutFeatureGroup,
    {},
    'bumpout',
    true,
    true,
    [],
    { firstFeature: null, firstConditions: null },
  )
}

export const isFeatureUnitUseEach = (feature) => {
  return feature.dbFeature.unit === "Each"
}

export const createApplianceFromFeature = (feature) => {
  const dbFeature = feature.dbFeature;
  const partId = feature.partId;
  const thirdPartyAR3DUrl = findGLBLink(dbFeature.thirdPartyAR3DUrls);// assume we have only one link to the model
  const thirdPartyAR3DMetaData = getThirdPartyAR3DMetaData(dbFeature, thirdPartyAR3DUrl);
  const width = getWidthFromDbFeature(dbFeature, thirdPartyAR3DMetaData);
  const depth = getDepthFromDbFeature(dbFeature, thirdPartyAR3DMetaData);

  console.log("dbFeature displayName", dbFeature.displayName);
  console.log("thirdPartyAR3DMetaData", thirdPartyAR3DMetaData);

  return createApplianceOnTheWorkspace(partId,
    dbFeature.id,
    {width, depth},
    {
      canSnap: true,
      isResizable: false
    }
  );
}

export const createApplianceOnTheWorkspace = (
  itemName,
  featureId = null,
  size = null,
  params = {
    canSnap: true,
    isResizable: true
  }) => {
  const getSize = (itemName) => {
    switch (itemName) {
      case SQFT_APPLIANCES.cabinetPlaceholder:
        return {width: 30, depth: 24}
      case SQFT_APPLIANCES.sink:
        return {width: 22, depth: 30}
      case SQFT_APPLIANCES.doubleSink:
        return {width: 22, depth: 33}
      case SQFT_APPLIANCES.dishwasher:
        return {width: 24, depth: 26}
      case SQFT_APPLIANCES_BATHROOM.tub:
      case SQFT_APPLIANCES_BATHROOM.toilet:
      case SQFT_APPLIANCES_BATHROOM.vanity:
      case SQFT_APPLIANCES_BATHROOM.wet_space:
        return {width: 30, depth: 26}
      default:
        return {width: 30, depth: 26}
    }
  }
  if (!size) {
    size = getSize(itemName);
  }

  let iconFullName = 'icon-'+ itemName +'-placeholder';
  let svg = document.getElementById(iconFullName);
  if (!svg) {
    console.log('svg not found', 'icon-'+ itemName +'-placeholder');
    return
  }
  //console.log('svg', iconFullName);

  let img = new Image(),
    xml = new XMLSerializer().serializeToString(svg), // get svg data
    svg64 = btoa(xml); // make it base64

  img.src = 'data:image/svg+xml;base64,' + svg64; // set it as the source of the img element

  const priority = !SQFT_APPLIANCES_ON_TOP_SHAPES.includes(itemName) && isSFTCabinetsGroup()
    ? sqftEventManager.priorities.APPLIANCE_ON_BOTTOM_SHAPE
    : sqftEventManager.priorities.APPLIANCE_ON_TOP_SHAPE

  const movableImage = workspace.addImage(
    img,
    size.width,
    size.depth,
    null,
    null,
    SHAPE_TYPE.appliances,
    itemName,
    function () {},
    undefined,
    null,
    null,
    priority,
    featureId,
    false,
    params
  );
  void movableImage
  //movableImage.setFeatureId(featureId);

  if (movableImage.shapeAutoShuffle) {
    movableImage.shapeAutoShuffle.handlePlaceShapeOnTheLine();
  }

  return movableImage;
}

export const getDbFeatureName = (dbFeature) => {
  return dbFeature.metaData.ActualDisplayedName
    ? dbFeature.customDisplayName && (dbFeature.customDisplayName !== dbFeature.sharedFeatureName)
      ? dbFeature.customDisplayName
      : metaData.ActualDisplayedName[0]
    : dbFeature.customDisplayName || dbFeature.displayName || dbFeature.sharedFeatureName;
};

/**
 * Sort features By Width ASC
 * @param features
 */
export const getSortedFeatures = (features) => {
  features.sort((a, b) => {
    const indexA = a.dbFeature.description.indexOf('Width');
    const indexB = b.dbFeature.description.indexOf('Width');

    // Check if 'Width' was found in descriptions
    if (indexA !== -1 && indexB !== -1) {
      const widthA = parseInt(a.dbFeature.description.substr(indexA + 6, 3), 10);
      const widthB = parseInt(b.dbFeature.description.substr(indexB + 6, 3), 10);

      return widthB - widthA;
    } else if (indexA !== -1) {
      // Place items without 'Width' in descriptions below
      return -1; // Move item b lower in the list
    } else if (indexB !== -1) {
      // Place items without 'Width' in descriptions below
      return 1; // Move item a lower in the list
    } else {
      // If neither has 'Width' in description, maintain current order
      return 0;
    }
  })

  return features
}

// const getSplittedDbFeatureName = (dbFeature) => {
//   if (dbFeature.customDisplayName == null) {
//     dbFeature.customDisplayName = dbFeature.sharedFeatureName || dbFeature.partName || "";
//     if (dbFeature.partId === "center_island_countertop") {
//       dbFeature.customDisplayName = dbFeature.customDisplayName
//         .replace(/2 0 /g, "")
//         .replace(/Center Island Countertop 1 /g, "");
//     }
//   }
//   return dbFeature.customDisplayName
// };
//
// export const getFilteredRelatedDbFeatures = (relatedDbFeaturesToCheck) => {
//   // console.log("relatedFeaturesToCheck", relatedFeaturesToCheck);
//   let relatedDbFeatures = [];
//   relatedDbFeaturesToCheck.forEach((relFeature) => {
//     const featureAlreadyExistIndex = relatedDbFeatures.findIndex(currentFeature => {
//       return getSplittedDbFeatureName(currentFeature) === getSplittedDbFeatureName(relFeature)
//     })
//     if (featureAlreadyExistIndex > -1) {
//       if (relFeature.getParent().navigationSubItems().some(navItem => {
//         return navItem.part.dbFeature.id === relFeature.dbFeature.id
//       })) {
//         relatedDbFeatures.splice(featureAlreadyExistIndex, 1, relFeature)
//       }
//     } else {
//       relatedDbFeatures.push(relFeature);
//     }
//   });
//   // console.log("relatedFeatures", relatedFeatures);
//   return relatedDbFeatures
// };
